import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import _sumBy from 'lodash-es/sumBy';
import { BalanceService } from 'src/app/api/balance.service';
import { ProfileService } from 'src/app/api/profile.service';
import { WebSocketService } from 'src/app/api/web-socket.service';
import { WebsocketBalancesService } from 'src/app/exchange/services/websocket-balances.service';
import { Balance } from 'src/app/models/balance';
import { Currency } from 'src/app/models/currency';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'user-portfolio',
  templateUrl: './user-portfolio.component.html',
  styleUrls: ['./user-portfolio.component.scss']
})
export class UserPortfolioComponent implements OnInit {
  public defaultFiatCurrency = 'AED';
  public loading = false;
  public error: string = null;
  public data: {currency: Currency, balance: Balance}[] = null;

  @Input() showPortfolio = false;
  @Output() showPortfolioChange = new EventEmitter();

  constructor(
    private wss: WebSocketService,
    private websocketBalancesService: WebsocketBalancesService,
    private balanceService: BalanceService,
    private profileService: ProfileService,
  ) { }

  ngOnInit() {
    this.getData();
    this.getProfileData();

    this.websocketBalancesService.get().subscribe(() => {
      this.getData();
    });

    this.wss.connectionChanges.subscribe(() => {
      this.getData();
    });
  }

  getData() {
    this.loading = true;
    this.error = null;
    this.balanceService.getExchange().subscribe(response => {
      this.loading = false;
      this.data = response;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  getProfileData() {
    this.profileService.getPreferences().subscribe(response => {
      this.defaultFiatCurrency = response.fiatCurrencyCode;
    }, err => {
      this.defaultFiatCurrency = environment.currencies.defaultCurrency;
    });
  }

  getTotal() {
    if (this.data) {
      return _sumBy(this.data, item => item?.balance?.value ? parseFloat(item.balance.value.amount) : 0);
    } else {
      return 0;
    }
  }

  onDropdownChange(state: Event) {
    if (!this.showPortfolio) {
      this.getData();
    }
    this.showPortfolio = !!state;
    this.showPortfolioChange.emit(this.showPortfolio);
  }

}
